import { Component, OnInit, TemplateRef } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-reusable-grid-template',
  templateUrl: './reusable-grid-template.component.html',
//   styleUrls: ['./reusable-grid-template.component.css']
})
export class ReusableGridTemplateComponent implements OnInit {

  constructor() { }

  public template: TemplateRef<any>;
  public context: any = {};
  public displayedValue: string = ''; // To store the display value
  private formatFunction: (data: any) => string;

  ngOnInit() {
  }

  agInit(params: ICellRendererParams) {
    this.setTemplateAndParams(params);
    this.displayedValue = this.extractDisplayedValue(params);
  }

  refresh(params: ICellRendererParams) {
    this.setTemplateAndParams(params);
    this.displayedValue = this.extractDisplayedValue(params);
  }

  setTemplateAndParams(params) {
    this.template = params['ngTemplate'];
    this.context = {
      rowInfo: {
        rowData: params?.data,
        rowId: params?.node?.id,
        columnName: params?.colDef?.headerName,
        key: params?.node?.key
      },
    };
    this.formatFunction = params?.formatFunction;
  }

  // Custom method to extract the displayed value
  extractDisplayedValue(params: ICellRendererParams): string {
    if (this.formatFunction) {
      return this.formatFunction(params.node.data);
    }

    return params.value; // Replace this with the actual logic
  }

}